<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Order Reports</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item"><a href="/">Reports</a>
                            </li>
                            <li class="breadcrumb-item active">Order Reports
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group"><label>Choose State</label><br>
                                <select class="form-control" v-model="state" @change="onStateChange">
                                    <option value="">All states</option>
                                    <option v-for="stateOption in states" :value="stateOption.id" :key="stateOption.id">
                                        {{ stateOption.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <template v-if="state!== ''">
                            <div class="col-md-4"><label></label><br>
                                <button type="button" class="btn btn-default" @click="resetStateFilter">Reset</button>
                            </div>
                        </template>
                    </div>
                </div>
            </div>

            <section class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-xl-3 col-md-4 col-sm-6"><label>Status</label><br>
                            <select class="form-control" v-model="status">
                                <option value="">Select Status</option>
                                <option v-for="statusOption in statuses" :key="statusOption"
                                        :value="statusOption">
                                    {{ statusOption }}
                                </option>
                            </select>
                        </div>
                        <div class="col-xl-3 col-md-4 col-sm-6"><label>Store</label><br>
                            <select class="form-control" v-model="store">
                                <option value="">All stores</option>
                                <option v-for="storeOption in filteredStores" :key="storeOption.id"
                                        :value="storeOption.id">
                                    {{ storeOption.name }}
                                </option>
                            </select>
                        </div>
                        <div class="col-xl-3 col-md-4 col-sm-6"><label>Order Type</label><br>
                            <select class="form-control" v-model="orderType">
                                <option value="">All</option>
                                <option v-for="type in orderTypes" :key="type" :value="type">
                                    {{ type }}
                                </option>
                            </select>
                        </div>
                        <div class="col-xl-3 col-md-4 col-sm-6"><label>Order Channel</label><br>
                            <select class="form-control" v-model="orderedFrom">
                                <option value="">Select the Platform</option>
                                <option v-for="(key,platform) in platforms" :key="key"
                                        :value="key">
                                    {{ platform }}
                                </option>
                            </select>
                        </div>
                        <div class="col-xl-3 col-md-4 col-sm-6 mt-1"><label>Payment Status</label><br>
                            <select class="form-control" v-model="paymentStatus">
                                <option value="">All</option>
                                <option v-for="paymentStatusOption in paymentStatuses" :key="paymentStatusOption"
                                        :value="paymentStatusOption">
                                    {{ paymentStatusOption }}
                                </option>
                            </select>
                        </div>
                        <div class="col-xl-3 col-md-4 col-sm-6 mt-1"><label>Payment Channel</label><br>
                            <select class="form-control" v-model="paymentChannel">
                                <option value="">All channels</option>
                                <option v-for="channel in paymentChannels" :key="channel" :value="channel">
                                    {{ channel }}
                                </option>
                            </select>
                        </div>
                        <div class="col-xl-3 col-md-4 col-sm-6 mt-1"><label>Product</label><br>
                            <select class="form-control" v-model="product">
                                <option value="">All products</option>
                                <option v-for="productOption in products" :key="productOption.id"
                                        :value="productOption.id">
                                    {{ productOption.name }}
                                </option>
                            </select>
                        </div>
                        <div class="col-xl-3 col-md-4 col-sm-6 mt-1"><label>Customer Type</label><br>
                            <select class="form-control" v-model="customerType">
                                <option value="">All customers</option>
                                <option value="new">New</option>
                                <option value="returning">Returning</option>
                            </select>
                        </div>
                        <div class="col-xl-3 col-md-4 col-sm-6 mt-1"><label>Start date</label><br>
                            <date-time-field class="form-control" v-model="from" bound="start"></date-time-field>
                        </div>
                        <div class="col-xl-3 col-md-4 col-sm-6 mt-1"><label>End date</label><br>
                            <date-time-field class="form-control" v-model="to" bound="end"></date-time-field>
                        </div>
                        <div class="col-xl-3 col-md-4 col-sm-6 mt-1"><label>&nbsp;</label><br>
                            <button type="submit" class="btn btn-primary" @click="getReport">Filter</button>
                            <button type="button" class="btn btn-default" @click="resetFilter">Reset</button>
                        </div>
                    </div>
                </div>
            </section>

            <section class="card">
                <div class="card-body">
                    <div class="row grouped-multiple-statistics-card">
                        <div class="col-12">
                            <div class="card mb-0">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 col-xl-6 col-sm-6 col-12">
                                            <div
                                                class="d-flex align-items-start mb-sm-1 mb-xl-0 border-right-blue-grey border-right-lighten-5">
                                                <span class="card-icon warning d-flex justify-content-center mr-3"><i
                                                    class="icon p-1 icon-basket-loaded customize-icon font-large-2 p-1"></i></span>
                                                <div class="stats-amount mr-3"><h3 class="heading-text text-bold-600">
                                                    {{ totalOrders }}
                                                </h3>
                                                    <p class="sub-heading">
                                                        Total number of orders
                                                    </p></div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-xl-6 col-sm-6 col-12">
                                            <div class="d-flex align-items-start"><span
                                                class="card-icon primary d-flex justify-content-center mr-3"><i
                                                class="icon p-1 icon-bar-chart customize-icon font-large-2 p-1"></i></span>
                                                <div class="stats-amount mr-3"><h3 class="heading-text text-bold-600">
                                                    ₦{{ totalAmount }}
                                                </h3>
                                                    <p class="sub-heading">
                                                        Total Income
                                                    </p></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p class="text-center mb-0 mt-2">
                        <b>{{ reportDurationLabel }}</b>
                    </p>
                </div>
            </section>

            <section class="card p-3">
                <div class="row">
                    <div class="col-md-6 mt-1">
                        <h4 class="content-header-title mb-2">Completed vs Cancelled Orders</h4>
                        <PieChart v-if="completedCancelledPie" :chart-data="completedCancelledPie"
                                  :chart-options="{responsive: true}"/>
                    </div>
                    <div class="col-md-6 mt-1">
                        <h4 class="content-header-title mb-2">Delivery vs Pickup Orders</h4>
                        <PieChart v-if="deliveryPickupPie" :chart-data="deliveryPickupPie"
                                  :chart-options="{responsive: true}"/>
                    </div>
                </div>
            </section>

            <section class="card p-3">
                <h4 class="content-header-title mb-2">Order Channel</h4>
                <div class="row">
                    <div class="col-md-6 mt-1">
                        <BarChart v-if="orderChannelCountBar" :chart-data="orderChannelCountBar"
                                  :chart-options="{responsive: true}"/>
                    </div>
                    <div class="col-md-6 mt-1">
                        <BarChart v-if="orderChannelAmountBar" :chart-data="orderChannelAmountBar"
                                  :chart-options="{responsive: true}"/>
                    </div>
                </div>
            </section>

            <section class="card p-3">
                <h4 class="content-header-title mb-2">Delivery vs Pickup Amount</h4>
                <BarChart v-if="deliveryPickupAmountBar" :chart-data="deliveryPickupAmountBar"
                          :chart-options="{responsive: true}"/>
            </section>

            <section class="card p-3">
                <div class="row">
                    <div class="col-md-6 mt-1">
                        <h4 class="content-header-title mb-2">Top Selling Products</h4>
                        <BarChart v-if="topProductsBar" :chart-data="topProductsBar"
                                  :chart-options="{responsive: true}"/>
                    </div>
                    <div class="col-md-6 mt-1">
                        <h4 class="content-header-title mb-2">Least Selling Products</h4>
                        <BarChart v-if="leastProductsBar" :chart-data="leastProductsBar"
                                  :chart-options="{responsive: true}"/>
                    </div>
                </div>
            </section>

            <section class="card p-3">
                <h3 class="content-header-title mb-0">Restaurants per state report</h3> <br>
                <div class="row">
                    <div class="col-lg-3 col-md-4 col-sm-6 d-flex">
                        <download-excel ref="form-csv" v-show="false" type="csv" :data="exportRows" :name="generateReportName('Orders_Report', '.csv')" sheet-name="Report" />
                        <download-excel ref="form-xls" v-show="false" :data="exportRows" :name="generateReportName('Orders_Report', '.xls')" />
                        <a href="#" @click.prevent="exportReportData('admin.reports.order', {}, filterParams, 'csv')" class="export-link">
                            <i class="fas fa-file-csv"></i> Export to CSV</a> | &nbsp;
                        <a href="#" @click.prevent="exportReportData('admin.reports.order', {}, filterParams, 'xls')" class="export-link text-warning">
                            <i class="fa fa-file-excel-o"></i> Export to Excel</a>
                    </div>
                    <div class="col-12">
                        <BarChart :chart-data="restaurantData" :chart-options='{responsive: true}'/>
                    </div>
                </div>
                <p class="text-center"><b>{{ month }}, {{ year }}</b></p>
            </section>

            <template v-if="state !== ''">
                <section class="card p-3"><h3 class="content-header-title mb-0">Order reports per state (By Year)</h3>
                    <br>
                    <form @submit.prevent="getStateReport">
                        <div class="d-flex justify-content-center mb-2">
                            <div class="col-xl-4 col-md-4"><label>Year</label><br>
                                <input type="number" min="1900" max="2099" step="1" v-model="year" class="form-control"
                                       placeholder="YYYY" pattern="\d{4}" title="Please enter a valid year (YYYY)">
                            </div>
                            <div class="col-xl-4 col-md-4"><label>Status</label><br>
                                <select class="form-control" v-model="status">
                                    <option value="">Select Status</option>
                                    <option v-for="statusOption in statuses" :key="statusOption"
                                            :value="statusOption">
                                        {{ statusOption }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-xl-4 col-md-4"><label>&nbsp;</label><br>
                                <button type="submit" class="btn btn-primary">Filter</button>
                            </div>
                        </div>
                    </form>

                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12 d-flex">
                                    <download-excel type="csv" :data="formattedPerMonthData" :name="'Monthly Orders Report(Orders).xls'"
                                                    :sheet-name="'Report'">
                                        <a href="#"
                                           class="export-link">
                                            <i class="fas fa-file-csv"></i> Export to CSV</a> | &nbsp;
                                    </download-excel>
                                    <download-excel :data="formattedPerMonthData" :name="'Monthly Orders Report(Orders).xls'">
                                        <a href="#" class="export-link text-warning">
                                            <i class="fa fa-file-excel-o"></i> Export to Excel</a>
                                    </download-excel>
                                </div>
                                <div class="col-lg-12 col-md-6 col-sm-12" v-if="totalOrderPerMonth">
                                    <BarChart :chart-data="totalOrderPerMonth" :chart-options='{responsive: true}'/>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12 d-flex">
                                    <download-excel type="csv" :data="formattedAmountPerMonthData" :name="'Monthly Orders Report(Amount).csv'"
                                                    :sheet-name="'Report'">
                                        <a href="#"
                                           class="export-link">
                                            <i class="fas fa-file-csv"></i> Export to CSV</a> | &nbsp;
                                    </download-excel>
                                    <download-excel :data="formattedAmountPerMonthData" :name="'Orders Report.xls'">
                                        <a href="#" class="export-link text-warning">
                                            <i class="fa fa-file-excel-o"></i> Export to Excel</a>
                                    </download-excel>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12" v-if="orderSumPerMonth">
                                    <BarChart :chart-data="orderSumPerMonth" :chart-options='{responsive: true}'/>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </template>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2';
import BarChart from "../../Shared/BarChart";
import PieChart from "../../Shared/PieChart";
import TableExportMixin from "../../Shared/Mixins/TableExportMixin";

export default {
    metaInfo: {title: 'Order Reports'},
    props: [
        'states', 'statuses',
        'totalOrders', 'salesPerStore',
        'totalAmount', 'platforms',
        'stores', 'products', 'orderTypes',
        'paymentStatuses', 'paymentChannels',
        'completedVsCancelled', 'orderChannels',
        'deliveryVsPickup', 'topProducts', 'leastProducts',
    ],
    layout: Layout,
    name: 'OrderReport',
    components: {
        BarChart,
        PieChart,
        Link,
    },
    mixins: [TableExportMixin],
    data: () => ({
        from: null,
        to: null,
        state: "",
        status: "",
        store: "",
        orderType: "",
        orderedFrom: "",
        paymentStatus: "",
        paymentChannel: "",
        product: "",
        customerType: "",
        restaurantData: null,
        completedCancelledPie: null,
        deliveryPickupPie: null,
        orderChannelCountBar: null,
        orderChannelAmountBar: null,
        deliveryPickupAmountBar: null,
        topProductsBar: null,
        leastProductsBar: null,
        totalOrderPerMonth: null,
        orderSumPerMonth: null,
        year: null,
        month: null,
        excelData: {},
        excelAmountPerMonthData: {},
        excelPerMonthData: {},
        exportRows: [],
    }),
    mounted() {
        this.year = new Date().getFullYear();
        this.month = new Date().toLocaleString('default', {month: 'long'});
        this.restaurantData = this.generateRestaurantReportDataset(this.salesPerStore, null)
        this.excelData = this.salesPerStore;
        this.assignMetrics({
            completedVsCancelled: this.completedVsCancelled,
            orderChannels: this.orderChannels,
            deliveryVsPickup: this.deliveryVsPickup,
            topProducts: this.topProducts,
            leastProducts: this.leastProducts,
        });
    },
    computed: {
        filteredStores() {
            if (!this.state) {
                return this.stores || [];
            }

            return (this.stores || []).filter(store => String(store.state_id) === String(this.state));
        },
        filterParams() {
            return {
                from: this.from,
                to: this.to,
                status: this.status,
                state: this.state,
                store: this.store,
                order_type: this.orderType,
                ordered_from: this.orderedFrom,
                payment_status: this.paymentStatus,
                payment_channel: this.paymentChannel,
                product: this.product,
                customer_type: this.customerType,
            };
        },
        reportDurationLabel() {
            if (this.from && this.to) {
                return `${this.formatReportDate(this.from)} to ${this.formatReportDate(this.to)}`;
            }

            return `${this.month} ${this.year}`;
        },
        formattedPerMonthData() {
            const rows = [];
            rows.push(['Month', 'Total Orders']);
            for (const key in this.excelPerMonthData) {
                rows.push([key, this.excelPerMonthData[key]]);
            }
            return rows;
        },
        formattedAmountPerMonthData() {
            const rows = [];
            rows.push(['Month', 'Total Amount']);
            for (const key in this.excelAmountPerMonthData) {
                rows.push([key, this.excelAmountPerMonthData[key]]);
            }
            return rows;
        }
    },

    methods: {
        formatReportDate(value) {
            return new Date(`${value}T00:00:00`).toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
            });
        },
        generateRestaurantReportDataset(report, label, backgroundColor = '#00B5B8') {
            let reportData = {
                labels: [],
                datasets: [],
            }

            let data = []

            for (const key in report) {
                reportData.labels.push(key);
                data.push(report[key]);
            }
            reportData.datasets.push({
                label,
                backgroundColor,
                data
            })
            return reportData;
        },

        pieThumbprint(labels, data, backgroundColor) {
            return {
                labels,
                datasets: [
                    {
                        backgroundColor,
                        data
                    }
                ]
            }
        },

        // Brand palette: teal + orange (matches Kilimanjaro order-report pies).
        chartColorFor(label) {
            const key = String(label || '').toLowerCase();
            const secondary = ['cancelled', 'pickup', 'pick-up', 'pick up'];

            return secondary.includes(key) ? '#FF9F40' : '#00B5B8';
        },

        assignMetrics(payload = {}) {
            const completedCancelled = payload.completedVsCancelled || {};
            const completedLabels = Object.keys(completedCancelled);
            this.completedCancelledPie = completedLabels.length
                ? this.pieThumbprint(
                    completedLabels,
                    completedLabels.map(key => completedCancelled[key]),
                    completedLabels.map(key => this.chartColorFor(key))
                )
                : null;

            const deliveryCounts = (payload.deliveryVsPickup && payload.deliveryVsPickup.counts) || {};
            const deliveryLabels = Object.keys(deliveryCounts);
            this.deliveryPickupPie = deliveryLabels.length
                ? this.pieThumbprint(
                    deliveryLabels,
                    deliveryLabels.map(key => deliveryCounts[key]),
                    deliveryLabels.map(key => this.chartColorFor(key))
                )
                : null;

            const deliveryAmounts = (payload.deliveryVsPickup && payload.deliveryVsPickup.amounts) || {};
            this.deliveryPickupAmountBar = Object.keys(deliveryAmounts).length
                ? this.generateRestaurantReportDataset(deliveryAmounts, 'Amount (₦)')
                : null;

            const channels = payload.orderChannels || [];
            this.orderChannelCountBar = channels.length
                ? {
                    labels: channels.map(item => item.platform),
                    datasets: [{
                        label: 'Orders',
                        backgroundColor: '#00B5B8',
                        data: channels.map(item => item.count),
                    }]
                }
                : null;
            this.orderChannelAmountBar = channels.length
                ? {
                    labels: channels.map(item => item.platform),
                    datasets: [{
                        label: 'Amount (₦)',
                        backgroundColor: '#FF9F40',
                        data: channels.map(item => item.total),
                    }]
                }
                : null;

            const topProducts = payload.topProducts || [];
            this.topProductsBar = topProducts.length
                ? {
                    labels: topProducts.map(item => item.product_name),
                    datasets: [{
                        label: 'Units sold',
                        backgroundColor: '#00B5B8',
                        data: topProducts.map(item => item.quantity),
                    }]
                }
                : null;

            const leastProducts = payload.leastProducts || [];
            this.leastProductsBar = leastProducts.length
                ? {
                    labels: leastProducts.map(item => item.product_name),
                    datasets: [{
                        label: 'Units sold',
                        backgroundColor: '#EA5455',
                        data: leastProducts.map(item => item.quantity),
                    }]
                }
                : null;
        },

        generateReportName(name, fileType) {
            let now = new Date();
            let formatted = now.getFullYear() + '-' +
                String(now.getMonth() + 1).padStart(2, '0') + '-' +
                String(now.getDate()).padStart(2, '0') + '_' +
                String(now.getHours()).padStart(2, '0') + '-' +
                String(now.getMinutes()).padStart(2, '0') + '-' +
                String(now.getSeconds()).padStart(2, '0');

            return `${name}_${formatted}${fileType}`;
        },

        async onStateChange() {
            this.store = "";
            await this.getReport();
        },

        async getReport() {
            try {
                let routeName = 'admin.reports.order';

                let response = await axios.get(route(routeName), {
                    params: {
                        ...this.filterParams,
                        api: true,
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });

                this.totalOrders = response.data.totalOrders;
                this.salesPerStore = response.data.salesPerStore;
                this.totalAmount = response.data.totalAmount;
                this.assignMetrics(response.data);

                this.excelData = response.data.salesPerStore;
                const selectedState = this.states.find((stateOption) => stateOption.id === this.state);
                this.restaurantData = this.generateRestaurantReportDataset(
                    this.salesPerStore,
                    selectedState ? `Store Report for ${selectedState.name} (${this.totalOrders})` : `Store Report (${this.totalOrders})`
                )
            } catch (e) {
                console.log(e);
            }
        },

        async getStateReport() {
            try {
                let routeName = 'admin.reports.order';

                let response = await axios.get(route(routeName), {
                    params: {
                        state: this.state,
                        year: this.year,
                        status: this.status,
                        api: true,
                        state_reports: true,
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });

                this.totalOrderPerMonth = this.generateRestaurantReportDataset(response.data.totalOrderPerMonth, "Total Number of Orders per Month")
                this.orderSumPerMonth = this.generateRestaurantReportDataset(response.data.orderSumPerMonth, "Total Amount of Orders per Month")
                this.excelAmountPerMonthData = response.data.orderSumPerMonth;
                this.excelPerMonthData = response.data.totalOrderPerMonth;

            } catch (e) {
                console.log(e);
            }
        },

        async resetStateFilter() {
            this.state = "";
            this.store = "";
            await this.getReport();
        },
        async resetFilter() {
            this.from = null;
            this.to = null;
            this.status = "";
            this.store = "";
            this.orderType = "";
            this.orderedFrom = "";
            this.paymentStatus = "";
            this.paymentChannel = "";
            this.product = "";
            this.customerType = "";
            await this.getReport();
        }
    },
}
</script>
